/* globals document, window */

require('public/css/search.scss');
const get = require('lodash/get');
const isNil = require('lodash/isNil');

const {
	getFacetValuesFromDom,
	getAvailableSearchFacetQueryNames,
} = require('public/js/components/search-facets');
const additionalSearchFilterHelpers = require('../templates/components/additional_search_filters/utils');

const THE_SCRIPT = function () {
	const $onReady = require('./lib/on-ready');
	const util = require('./plugin/lib/util');
	const { trackImpressionsEvent, trackCategoryListEvent } = require('public/js/lib/adobe-dtm-helper');

	const vehicleParams = ['year', 'make', 'model'];
	let searchFacetParams = []; // set after onReady
	const search = {
		type: 'search',
		category: '',
	};

	search.getSearchResults = function (changedField, params) {
		let historyUrl;
		if (changedField !== 'history') {
			historyUrl = this.buildHistoryUrl(params);
		}

		if (window.__DISABLE_SEARCH_HISTORY_HANDLER) {
			rp_app.location.redirect(historyUrl);
			return;
		}

		rp$(document).trigger('searchResults:request');
		$ajax({
			method: 'GET',
			dataType: 'json',
			data: params,
			url: this.buildFetchUrl(),
			error: (jqxhr, textStatus) => {
				if (textStatus === 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.maxRetry) {
						$ajax(this);
						return;
					}
				}

				rp$(document).trigger('searchResults:error');
			},
			success: (response, status) => {
				if(status !== 'success') { return; }

				// Handle the single product redirect to product page case
				if (response && response.redirect_url) {
					rp_app.location.redirect(response.redirect_url);
					return;
				} else if (!isNil(historyUrl)) {
					try {
						if(this.type === 'dynamic_seo') {
							window.history.pushState(params, '', historyUrl);
						} else {
							window.history.pushState({}, '', historyUrl);
						}
					}
					catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
					historyUrl = null;
				}

				// DTB-402 Count this as a page view & featured products impression
				// If analytics are enabled, count this as another page view
				if (rp_app.env.google_analytics_enabled) {
					window.tracking.ec.products = response.tracking_products;  // Set tracking products so they can be used by Enhanced Ecommerce Product Impressions if enabled
					rp_app.track.track_pageview_all_trackers();
				}

				this.handleAdobeDTMTracking(this.type, response.tracking_products);

				rp$(document).trigger('searchResults:response', response);
			}
		});
	};

	search.buildFetchUrl = function () {
		switch (this.type) {
			case 'dynamic_seo':
				return '/ajax/dynamic-seo-search';
			case 'cfc_search':
				return `/ajax/category-search/${this.category}`;
			case 'vehicle-picker-category':
				return `/ajax/vp-category-search/${this.category}--${this.subcategory}`;
			default:
				return '/ajax/search';
		}
	};

	search.buildHistoryUrl = function (requestParams) {
		let historyUrl;
		let base = rp$('base').attr('href');

		if (!base || typeof base === 'string') {
			base = rp_app.location.getBase();
		}
		const baseUrl = base;
		const currentUrlParams = rp_app.query.all();
		let currentPath;

		if (this.type === 'dynamic_seo' || this.type === 'vp-picker-category') {
			currentPath = requestParams.page_url;
			const filterParam = this.buildDynamicSeoFilterParam(requestParams);
			historyUrl = util.addTrailingSlash(baseUrl) + currentPath;
			if (filterParam) {
				historyUrl += '/' + filterParam;
			}

			// Ensure we keep search facet query params around
			const params = searchFacetParams.reduce((accumulator, searchFacetParam) => {
				accumulator[searchFacetParam] = requestParams[searchFacetParam];
				return accumulator;
			}, {});
			const targetParams = rp$.extend(currentUrlParams, params);
			historyUrl += `?${rp$.param(targetParams)}`;
		} else {
			currentPath = rp_app.location.pathname.replace(/^\//, '');
			const targetParams = rp$.extend(currentUrlParams, requestParams);
			historyUrl = baseUrl +'/'+ currentPath +'?'+ rp$.param(targetParams);
		}

		return historyUrl;
	};

	search.getDseoFilterParamsFromDom = function() {
		const params = {};
		vehicleParams.forEach((vehicleParam) => {
			const $option = rp$(`.refine-search-form .refine-select[data-refine=${vehicleParam}] option[selected]`);
			if ($option.length > 0) {
				params[vehicleParam] = $option.attr('value');
			}
		});

		return params;
	};

	search.buildDynamicSeoFilterParam = function (requestParams) {
		const paramArr = [];
		const domFilterParams = search.getDseoFilterParamsFromDom();
		vehicleParams.forEach((vehicleParam) => {
			if (requestParams[vehicleParam]) {
				paramArr.push(requestParams[vehicleParam]);
			} else if (domFilterParams[vehicleParam] && !(typeof requestParams[vehicleParam] === 'string')) {
				// If filter not provided, try to infer from the DOM
				paramArr.push(domFilterParams[vehicleParam]);
			}
		});

		return paramArr.join('-');
	};

	search.handleHistoryChange = function(evt) {
		var params;
		var args = rp_app.query.all(rp_app.location.href);

		/* If we don't have arguments from the URL and we're in a dynamic SEO Context,
		 * check to see if we have arguments stored in the state
		.*-----------------------------------------*/
		if ((search.type === 'dynamic_seo') && (typeof evt.state === 'object') && (evt.state !== null)) {
			args.make = evt.state.make;
			args.model = evt.state.model;
			args.year = evt.state.year;
			args.page_id = evt.state.page_id;
			args.page_url = evt.state.page_url;

			if(evt.state.redirect_url) {
				rp_app.location.redirect(evt.state.redirect_url);
				return;
			}
		}

		params = {
			page: args.page,
			search_str: decodeURIComponent(args.search_str),
			year: args.year || '',
			make: args.make || '',
			model: args.model || '',
			page_id: args.page_id || '',
			catalog_type: search.getSelectedCategoryCatalogType()
		};
		if (!isNaN(parseInt(args.ptid, 10))) {
			params.ptid = decodeURIComponent(args.ptid);
		}
		searchFacetParams.forEach((facet) => {
			if (args[facet]) {
				params[facet] = decodeURIComponent(args[facet]);
			}
		});

		search.getSearchResults('history', params);
	};

	search.hookPageHistory = function () {
		window.addEventListener('popstate', this.handleHistoryChange);

		/* For Dynamic SEO pages, treat the root page as a static page. Save the URL to be called when we navigate back to it
		.*-----------------------------------------*/
		if(this.type === 'dynamic_seo') {
			try {
				window.history.replaceState({
					redirect_url: rp_app.location.href
				}, '', rp_app.location.href);
			}

			catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */}
		}
	};

	search.handlePageChange = function(pageNum) {
		const args = rp_app.query.all(rp_app.location.href);
		let vpCategorySearchParams = {};

		if (search.type === 'cfc_search') {
			const params = {
				page: pageNum,
			};

			search.getSearchResults('page', params);
			return;
		} else if (search.type === 'vehicle-picker-category') {
			vpCategorySearchParams = this.getVPVehicleParams();
		}

		const params = {
			page: pageNum,
			search_str: decodeURIComponent(args.search_str),
			year: args.year || vpCategorySearchParams.year || '',
			make: args.make || vpCategorySearchParams.make || '',
			model: args.model || vpCategorySearchParams.model || '',
			catalog_type: search.getSelectedCategoryCatalogType()
		};
		if (!isNaN(parseInt(args.ptid, 10))) {
			params.ptid = decodeURIComponent(args.ptid);
		}
		searchFacetParams.forEach((facet) => {
			if (args[facet]) {
				params[facet] = decodeURIComponent(args[facet]);
			}
		});

		search.getSearchResults('page', params);
	};

	search.getSelectedCategoryCatalogType = function() {
		let selectedCatalogType = 'parts';

		const activeCategoryElements = rp$.find('.active-cat');
		if (Array.isArray(activeCategoryElements) && activeCategoryElements.length) {
			const activeCategory = activeCategoryElements[0];
			const closestCardParent = activeCategory.closest('.card');

			if (closestCardParent) {
				const cardParentClasses = closestCardParent.classList;

				if (cardParentClasses && cardParentClasses.contains('accessories')) {
					selectedCatalogType = 'accessories';
				}
			}
		}

		return selectedCatalogType;
	};

	search.getVPVehicleParams = function() {
		let params = {};
		let vpGarage =  rp$('.vp-category-garage');

		if (vpGarage && vpGarage.length) {
			vpGarage = vpGarage[0];
			params.year = vpGarage.getAttribute('data-vehicle-year');
			params.make = vpGarage.getAttribute('data-vehicle-make');
			params.model = vpGarage.getAttribute('data-vehicle-model');
		}

		return params;
	};

	search.handleAdobeDTMTracking = function(searchType, products = null) {

		if (!get(window, 'digitalData.newEvent')) {
			return;
		}

		let adobeDTMProducts = null;

		// Adobe DTM requires product prices to be in string form
		if (Array.isArray(products)) {
			adobeDTMProducts = products.map(product => {
				product.price = String(product.price);
				return product;
			});
		}
		if (searchType === 'accessories' || searchType === 'cfc_search') {
			const productRows = rp$('.catalog-product.marketplace-product');
			// Track Adobe DTM category page view
			if (productRows.length) {

				if (adobeDTMProducts) {
					window.digitalData.products.listing = adobeDTMProducts;
				}
				trackCategoryListEvent();
			}
		} else {
			// Regular searches & dseo searches can be treated as impression events
			if (adobeDTMProducts) {
				window.digitalData.products.impressions = adobeDTMProducts;
			}
			trackImpressionsEvent();
		}
	};

	if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
		search.hookPageHistory();

		rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
			evt.preventDefault();
			search.handlePageChange(pageNum);
		});
	}

	$onReady({rp$, window,
		label: 'search',
		fn: function() {
			searchFacetParams = getAvailableSearchFacetQueryNames();
			const moduleSearchType = rp$('.search-listing-module').data('search-type');
			if(moduleSearchType) {
				search.type = moduleSearchType;
			}

			search.handleAdobeDTMTracking(search.type);

			const moduleCategory = rp$('.search-listing-module').data('category');
			if (moduleCategory) {
				search.category = moduleCategory;
			}

			const moduleSubcategory = rp$('.search-listing-module').data('subcategory');
			if (moduleSubcategory) {
				search.subcategory = moduleSubcategory;
			}

			const $additionalFilters = rp$('.additional-filter-form');
			if ($additionalFilters.length > 0) {
				$additionalFilters.on('changeAdditionalFilters', function handleAdditionalFilterChange(evt, filters) {
					const combinedFilters = {
						...filters,
						...getFacetValuesFromDom(),
					};
					search.getSearchResults('', combinedFilters);
				});
			}

			const $filtersModule = rp$('.search-filters-module .refine-search-form');
			if ($filtersModule.length > 0)  {
				$filtersModule.on('changeFilters', function handleFilterChange(evt, changedField, filters) {
					// Factor existing facets into search
					const facetParams = getFacetValuesFromDom();
					const additionalFilters = additionalSearchFilterHelpers.getAdditionalFilterValuesFromDom();
					const updatedParams = { ...filters, ...facetParams, ...additionalFilters };
					search.getSearchResults(changedField, updatedParams);
				});
			}

			const $facetsModule = rp$('.search-facets-module');
			if ($facetsModule.length > 0) {
				$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
					// Factor existing vehicle filter params into search
					const vehicleFilterParams = search.getDseoFilterParamsFromDom();
					const additionalFilters = additionalSearchFilterHelpers.getAdditionalFilterValuesFromDom();
					const updatedParams = { ...queryParams, ...vehicleFilterParams, ...additionalFilters };
					search.getSearchResults('', updatedParams);
				});
			}
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
